window.adsNinja                        = window.adsNinja || {};
window.adsNinja.queue                  = window.adsNinja.queue || [];
window.adsNinja.isInjectorInjected     = window.adsNinja.isInjectorInjected || false;
window.adsNinja.logger                 = new AdsNinjaLogger();
window.adsNinja.benchmarker            = new ANBenchmarker(window.adsNinja.logger);
window.adsNinja.eventHelper            = new AdsNinjaEventHelper();
window.adsNinja.utils                  = new AdsNinjaUtils();
window.adsNinja.zoneDelegate           = null;
window.adsNinja.injector               = null;
window.adsNinja.floatingManager        = null;
window.adsNinja.videoRenderer          = null;
window.adsNinja.data                   = null;
window.adsNinja.valstream              = null;
window.adsNinja.__firstQueueProcessing = true;
window.adsNinja.telemetry              = null;
window.adsNinja.initialized            = false;
window.adsNinja.initTime               = null;
window.adsNinja.sessionId              = null;
window.adsNinja.floorHelper            = null;
window.adsNinja.ID_STATE_UNINITIALIZED = 0;
window.adsNinja.ID_STATE_INITIALIZED   = 1;
window.adsNinja.ID_STATE_STARTED       = 2;
window.adsNinja.ID_STATE_READY         = 3;
window.adsNinja.state                  = window.adsNinja.ID_STATE_UNINITIALIZED; // States: {0: 'uninitialized', 1: 'initialized', 2: 'started', 3: 'ready'}.

//
// Process queue of closures.
window.adsNinja.processQueue = function(){

    // Execute all closures currently in the queue.
    while(window.adsNinja.queue.length > 0){

        var closure = window.adsNinja.queue.shift();

        try{

            closure();
        }
        catch(error){

            this.logger.error('Error encountered while processing AdsNinja queue.', {
                message: error.message,
                closure: closure,
            });
        }
    }

    if(this.__firstQueueProcessing){

        // Override methods to call our handler.
        // This way closures pushed to the queue will be executed immediately from this point on.
        window.adsNinja.queue.push = function(){

            Array.prototype.push.apply(this, arguments);
            window.adsNinja.processQueue();
        };

        window.adsNinja.queue.unshift = function(){

            Array.prototype.unshift.apply(this, arguments);
            window.adsNinja.processQueue();
        };

        this.__firstQueueProcessing = false;
    }
};

/**
 * Dispatch window event.
 * 
 * @param {string} eventName
 */
window.adsNinja.dispatchWindowEvent = function(eventName){
    
    this.state = this.__getAssociatedState(eventName);

    this.logger.debug(`Dispatching window event: ${eventName}.`);

    window.dispatchEvent(new Event(eventName));
};

//
// Initialize AdsNinja.
window.adsNinja.init = function(){

    if(this.initialized){

        return;
    }

    this.initialized = true;
    this.initTime    = Date.now();
    this.sessionId   = this.generateUUID();

    this.__registerEventListeners();

    if(window.ANTelemetry && typeof window.ANTelemetry !== 'undefined'){

        window.adsNinja.telemetry = new ANTelemetry(this.sessionId);
    }

    if(window.Valstream && typeof window.Valstream !== 'undefined'){

        window.adsNinja.valstream = new window.Valstream({
            biddingManager: window.adsNinjaHeaderBiddingManager || null,
            googleAnalytics: window.ga || null,
            videoJsLibrary: window.videojs || null,
            googleLibrary: window.google || null,
        });
    }
    else{

        this.logger.error('Valstream is not defined.');
    }

    if(window.AdsNinjaVideoRenderer && typeof window.AdsNinjaVideoRenderer !== 'undefined'){

        window.adsNinja.videoRenderer = new AdsNinjaVideoRenderer(window.adsNinja.telemetry.getLogger());
    }
    else{

        this.logger.error('AdsNinjaVideoRenderer is not defined.');
    }

    if(window.ANZoneDelegate && typeof window.ANZoneDelegate !== 'undefined' && window.ANInjector && typeof window.ANInjector !== 'undefined'){

        this.zoneDelegate = new ANZoneDelegate(this.logger);
        this.injector     = new ANInjector(this.zoneDelegate, this.valstream, this.logger);
    }
    else{

        this.logger.error('ANZoneDelegate or ANInjector is not defined.');
    }

    // Fire initialization event.
    this.dispatchWindowEvent('ANInitialized');

    this.processQueue();
}

//
// Register event listeners.
window.adsNinja.__registerEventListeners = function(){

    var self = this;

    //
    // AdsNinja video player events.
    window.addEventListener('AdsNinjaVideoPlayerLoggableEvent', function(event){

        event.stopImmediatePropagation();

        // window.adsNinja.recordEvent(event.detail.elementId, event.detail.type, event.detail.message, event.detail.value, event.detail.data);
    });

    //
    // AdsNinja video player events.
    window.addEventListener('AdsNinjaVideoPlayerEvent', function(event){

        event.stopImmediatePropagation();

        switch(event.detail.type){

            case 'click':
    
                self.handleVideoPlayerPlay(event.detail.elementId);
    
                break;
    
            // case 'pause':
    
            //     self.handleVideoPlayerPause(event.detail.elementId);
    
            //     break;
        }
    });

    //
    // AdsNinja video player Sentinel events.
    window.addEventListener('AdsNinjaVideoPlayerSentinelEvent', function(event){

        event.stopImmediatePropagation();

        window.adsNinja.recordSentinelEvent(event.detail.elementId, event.detail.type, event.detail.message, event.detail.value, event.detail.data);
    });

    // Injector events.
    var dissmissElements = document.getElementsByClassName('article-limit-drawer-close');

    if(dissmissElements && dissmissElements.length > 0){

        var handledLoginDrawerDismissal = false;
        var dismissLoginDrawerHandler   = function(){
    
            if(handledLoginDrawerDismissal){
    
                return;
            }
    
            handledLoginDrawerDismissal = true;
    
            setTimeout(function(){

                window.adsNinja.runInjector();
            }, 1000);
        };
    
        for(var i = 0; i < dissmissElements.length; i++){

            var element = dissmissElements[i];
    
            element.addEventListener('click', dismissLoginDrawerHandler.bind(this));
            element.addEventListener('touchend', dismissLoginDrawerHandler.bind(this));
        }
    }
};
//
// Handle video player play.
window.adsNinja.handleVideoPlayerPlay = function(elementId){
    
    if(!window.adsNinjaHeaderBiddingManager 
        || typeof window.adsNinjaHeaderBiddingManager !== 'object' 
        || typeof window.adsNinjaHeaderBiddingManager.initFloatingIfNotAleadyInitialized !== 'function'
        || typeof window.adsNinjaHeaderBiddingManager.enableFloating !== 'function'
    ){

        return;
    }

    window.adsNinjaHeaderBiddingManager.initFloatingIfNotAleadyInitialized(elementId);
    window.adsNinjaHeaderBiddingManager.enableFloating(elementId);

    // var ad = window.adsNinjaHeaderBiddingManager.getAdsData(elementId);

    // if(!ad || ad.hasAutoplayAndIsOutstreamWithFloating()){
        
    //     return;
    // }

    // // Pause outstream video player.
    // var outstreamAd = window.adsNinjaHeaderBiddingManager.getAdByZone('content', 'outstream');

    // if(outstreamAd){

    //     var outstreamAdElementId = outstreamAd.getAdElementId();
    //     var outstreamVideoPlayer = this.getVideoPlayer(outstreamAdElementId);

    //     if(outstreamVideoPlayer){
            
    //         // Pause outstream video player.
    //         outstreamVideoPlayer.pause();

    //         // Disable floating waypoint if exists.
    //         window.adsNinjaHeaderBiddingManager.disableFloatingAdWaypoints(outstreamAdElementId);

    //         // Handle floating disengaged.
    //         window.adsNinjaHeaderBiddingManager.handleFloatingDisengaged(outstreamAdElementId);
            
    //         outstreamVideoPlayer.disableAutoplay();
    //     }
    // }
};

//
// Handle video player pause.
window.adsNinja.handleVideoPlayerPause = function(elementId){
    
    if(!window.adsNinjaHeaderBiddingManager){

        return;
    }

    var ad = window.adsNinjaHeaderBiddingManager.getAdsData(elementId);
    
    if(!ad || ad.hasAutoplayAndIsOutstreamWithFloating() || !window.adsNinjaHeaderBiddingManager.getHasLoadedInfiniteArticle()){
        
        return;
    }

    // Play outstream video player.
    var outstreamAd = window.adsNinjaHeaderBiddingManager.getAdByZone('content', 'outstream');

    if(outstreamAd){

        var outstreamAdElementId = outstreamAd.getAdElementId();
        var outstreamVideoPlayer = this.getVideoPlayer(outstreamAdElementId);

        if(outstreamVideoPlayer){

            outstreamVideoPlayer.enableAutoplay();
            
            // Enable floating waypoint if exists.
            window.adsNinjaHeaderBiddingManager.enableFloatingAdWaypoints(outstreamAdElementId);

            // Play outstream video player.
            outstreamVideoPlayer.play();
        }
    }
};

//
// Send telemetry event.
window.adsNinja.sendTelemetryEvent = function(type, message = null, data = null, successCallback = null, errorCallback = null, useBeacon = false, includeChosenAdSetup = true, clientDataParamsToNotInclude = [], includeMessage = true, recordingOptions = {}){

    if(!window.adsNinja.telemetry || typeof window.adsNinja.telemetry === 'undefined'){

        this.logger.debug('Unable to send telemetry: missing telemetry object.', {
            elementId: elementId,
            type: type,
            message: message,
            data: data,
        }, false);
        
        return;
    }

    this.telemetry.send(type, message, data, successCallback, errorCallback, useBeacon, includeChosenAdSetup, clientDataParamsToNotInclude, includeMessage, recordingOptions);
};

//
// Record Sentinel event.
window.adsNinja.recordSentinelEvent = function(elementId, type, message = null, value = null, data = null){

    // Get identifier.
    var eventRecordingData = window.adsNinjaHeaderBiddingManager.getEventRecordingData(elementId)|| null;
    var clientData         = null;
    var placementId        = null;

    // For backwards compatibility.
    if(eventRecordingData && typeof eventRecordingData === 'string'){

        placementId = eventRecordingData;
        clientData  = window.adsNinjaHeaderBiddingManager.getEventRecordingLogData()|| null;
    }
    else if(eventRecordingData && typeof eventRecordingData === 'object' && Object.keys(eventRecordingData).length > 0 && eventRecordingData.hasOwnProperty('id')){

        placementId = eventRecordingData['id'];
        clientData  = eventRecordingData['clientData'];
    }
    else{

        this.logger.debug('Unable to record event: missing tracking identifier.', {
            elementId: elementId,
            type: type,
            message: message,
            data: data,
            eventRecordingData: eventRecordingData,
        });
        return;
    }

    if(!clientData || typeof clientData !== 'object'){

        this.logger.error('Unable to record event: missing clientData.', {
            elementId: elementId,
            type: type,
            message: message,
            data: data,
            eventRecordingData: eventRecordingData,
            clientData: clientData,
        });
        return;
    }

    window.adsNinjaHeaderBiddingManager.sendVideoPixelEvent(placementId, type, clientData, message, value, data);
};

//
// Sets up video players for zones specified by the bidding manager.
window.adsNinja.configureBiddingManagerVideoPlayers = function(){

    this.__waitForReadyEvent(function(){

        if(typeof window.adsNinja.valstream !== 'undefined' && typeof window.adsNinja.valstream.configureBiddingManagerVideoPlayers === 'function'){

            window.adsNinja.valstream.configureBiddingManagerVideoPlayers();
        }
    });
};

//
// Dynamically inject all ad zones possible.
window.adsNinja.dynamicallyInjectAllAdZones = function(){

    if(typeof window.googletag !== 'undefined' && window.googletag.hasOwnProperty('cmd') && typeof window.adsNinjaHeaderBiddingManager !== 'undefined'){

        window.googletag.cmd.push(function(){

            // window.adsNinjaDefineSlots(false);

            // var didDynamicallyInjectAdZones = window.adsNinjaHeaderBiddingManager.dynamicallyInjectAdZones(window.adsNinja.data['dynamicallyInjectedAdZones']);

            // if(!didDynamicallyInjectAdZones || didDynamicallyInjectAdZones.length === 0){

            //     return;
            // }

            var adsNinjaAuction2 = window.adsNinjaHeaderBiddingManager.setup(window.adsNinjaHeaderBiddingManager.getAllAdsData());

            window.adsNinjaHeaderBiddingManager.setupDynamicallyInjectionRefreshAdZones(adsNinjaAuction2.getGamAdSlots(), window.adsNinja.data['dynamicInjectionRefreshAdZones']);
            window.adsNinjaHeaderBiddingManager.requestHeaderBids(adsNinjaAuction2.getId());
            window.adsNinjaHeaderBiddingManager.startFailSafeTimeout(adsNinjaAuction2.getId());
            window.adsNinjaHeaderBiddingManager.setupFloatingAdZones(adsNinjaAuction2.getGamAdSlots());
        });
    }
}

//
// Returns video player.
window.adsNinja.getVideoPlayer = function(elementId){

    if(!elementId){

        return null;
    }

    return this.valstream.getVideoPlayer(elementId) || null;
};

//
// Clean function input.
window.adsNinja.cleanFunctionInput = function(string){

    return this.removeHtmlComments(this.stripScriptTags(string));
};

//
// Strips script tags.
window.adsNinja.removeHtmlComments = function(string){

    return string.replace(/<!--.*?-->/g, '');
};

//
// Strips script tags.
window.adsNinja.stripScriptTags = function(string){

    return string.replace(/<script.*?>/g, '').replace('</script>', '');
};

//
// Runs ad auctions.
window.adsNinja.__runBiddingManager = function(){

    var self           = this;
    var data           = this.data;
    this.__siteConfig  = data['siteConfig'] || {};
    
    var brandName = this.data['logData']['clientData']['brandName'] || 'unknown';

    var connectionType = 'fast';

    if(navigator.connection){
        if(navigator.connection.downlink <= 0.50){

            connectionType = 'very slow';
        }else if(navigator.connection.downlink > 0.50 && navigator.connection.downlink <= 2.00){
                
            connectionType = 'slow';
        }
    }

    if (connectionType != 'fast') {
        this.logger.debug('ads bidding impacted by connection type', {
            brandName: brandName,
            connection: navigator.connection.downlink,
            connectionType: connectionType,
            connectionConfig: data['connectionConfig']
        });
    }

    data.connectionType = connectionType;

    //check if ads are disabled
    var isNoAdsMode = 0;
    if (this.data['modeAds'] == undefined || (this.data['modeAds'] !== undefined && this.data['modeAds'] === 2)) {
        isNoAdsMode = 1;
    } else {
        if (data['connectionConfig'] && data['connectionConfig'][data['connectionType']]) {
            if (data['connectionConfig'][data['connectionType']]['adsDisabled'] === true) {
                isNoAdsMode = 1;
            }
        }
    }

    if (isNoAdsMode === 1) {
        return;
    }

    if (this.data['modeAds'] !== undefined && this.data['modeAds'] === 1) {

        if(typeof window.googletag === 'undefined' || !window.googletag.hasOwnProperty('cmd') || typeof window.adsNinjaHeaderBiddingManager === 'undefined'){

            this.logger.error('One or more of the following is not defined on page: googletag, googletag.cmd, and/or adsNinjaHeaderBiddingManager.');
            return;
        }
    }

    window.googletag.cmd.push(function(){
        window.googletag.pubads().setTargeting('connection', connectionType);
    });

    if(this.data && this.data.hasOwnProperty('floors') && typeof this.data['floors'] === 'object' && Object.keys(this.data['floors']).length > 0){

        var geo = (this.data.hasOwnProperty('logData') && this.data.logData.hasOwnProperty('clientData') && this.data.logData.clientData.hasOwnProperty('geo') && this.data.logData.clientData.geo) ? this.data.logData.clientData.geo : null;

        this.floorHelper = new ANFloorHelper(this.logger, this.data['floors'], geo);
    }

    var refreshData = data.dynamicInjectionRefreshAdZones || data.adRefreshData;

    // Initialize modules.
    window.adsNinjaHeaderBiddingManager.init(data);
    window.adsNinja.zoneDelegate.init(data.adsData || [], refreshData || []);

    this.runInjector(true);

    // Fire initialization event.
    this.dispatchWindowEvent('ANStarted');

    this.scheduleOnReadyState('complete', function(){

        // TODO: Don't use the preAuctionCallback.
        window.adsNinjaHeaderBiddingManager.run(data, function(){

            if(data['usingVideoPlayer'] && typeof window.adsNinja.valstream !== 'undefined'){

                window.adsNinja.valstream.configureBiddingManagerVideoPlayers();
            }
        }, null);

        // Fire initialization event.
        self.dispatchWindowEvent('ANReady');
    });
};

//
// Run injector.
window.adsNinja.runInjector = function(isPageLoad = false){

    try{

        // Inject zones.
        this.injector.run(this.data, isPageLoad);
    }
    catch(error){

        this.logger.error(error);
    }
}

//
// Run method.
window.adsNinja.run = function(data){

    this.data        = data;                            // For backwards compatibility, store data for use later.
    var validDomain  = false;
    var validDomains = this.data['allowedDomains'];

    if(validDomains && validDomains.length > 0){

        for(var x in validDomains){

            if(-1 !== window.location.hostname.indexOf(validDomains[x])){

                validDomain = true;

                break;
            }
        }
    }
    else{

        validDomain = true;
    }

    if(window.AdsNinjaFloatingManager 
        && typeof window.AdsNinjaFloatingManager !== 'undefined'
        && window.AdsNinjaFloatingStrategy
        && typeof window.AdsNinjaFloatingStrategy !== 'undefined'
        && window.AdsNinjaFloatingStrategySingleVideo
        && typeof window.AdsNinjaFloatingStrategySingleVideo !== 'undefined'
    ){

        var videoCallbacks = {
            getElementsToIgnore: function(){
          
                return window.adsNinjaHeaderBiddingManager.getOutstreamVideoPlayerElements();
            },
        };

        var bannerStrategy = new AdsNinjaFloatingStrategy(this.logger);
        var videoStrategy  = null;          

        if(window.adsNinja.data.hasOwnProperty('deviceType') && 'desktop' === window.adsNinja.data.deviceType){

            var videoStrategy = new AdsNinjaFloatingStrategySingleVideo(this.logger);
        }
        else{

            var videoStrategy = new AdsNinjaFloatingStrategySingleNonOutstreamVideo(this.logger, {}, videoCallbacks);
        }

        window.adsNinja.floatingManager = new AdsNinjaFloatingManager(this.logger, bannerStrategy, videoStrategy);
    }
    else{

        this.logger.error('AdsNinjaFloatingManager is not defined.');
    }

    if(validDomain){

        window.adsNinja.__runBiddingManager();
    }
    else{

        this.logger.error('Domain invalid, unable to load ads.');
    }
};

window.adsNinja.runForExtendedSection = function(data){

    var connectionType = 'fast';
    var brandName      = this.data['logData']['clientData']['brandName'] || 'unknown';

    if(navigator.connection){

        if(navigator.connection.downlink <= 0.50){

            connectionType = 'very slow';

            this.logger.debug('ads bidding impacted by connection type, no ads', {
                brandName: brandName,
                connection: navigator.connection.downlink,
            });
        }
    }

    if(this.data['modeAds'] == undefined || (this.data['modeAds'] !== undefined && this.data['modeAds'] === 2) || connectionType == 'very slow'){

        return;
    }

    window.adsNinjaHeaderBiddingManager.runForExtendedSection(data);
}

window.adsNinja.getExtendedSectionAdRequestData = function(isLoadingNextArticle = true){

    if(this.data['modeAds'] == undefined || (this.data['modeAds'] !== undefined && this.data['modeAds'] === 2)){

        this.data['adCountData']['articleNumber'] = this.data['adCountData']['articleNumber'] + 1;
        this.data['adCountData']['pageNumber'] = this.data['adCountData']['pageNumber'] + 1;

        return {
       
            adCountData: this.data['adCountData']
        };
    }

    return window.adsNinjaHeaderBiddingManager.getExtendedSectionAdRequestData(isLoadingNextArticle);
}

//
// Render method.
window.adsNinja.render = function(options){

    try{

        switch(options['type']){
        
            case 'video':
    
                if(typeof window.adsNinja.videoRenderer !== 'undefined'){
    
                    window.adsNinja.videoRenderer.render(options);
                }
                else{
    
                    window.adsNinja.logger.error('Video renderer not defined.', options);
                }
    
                break;
    
            default:
    
                window.adsNinja.logger.error(`Invalid render header bidding library: ${options['headerBiddingLibrary']}.`, options);
                
                break;
        }
    }
    catch(error){
        
        window.adsNinja.logger.error(error, options, false);
    }    
};

//
// Play if video.
window.adsNinja.playIfVideo = function(adElementId){

    var adsNinjaVideoPlayer = this.getVideoPlayer(adElementId);

    if(adsNinjaVideoPlayer && typeof adsNinjaVideoPlayer.play === 'function'){

        return adsNinjaVideoPlayer.play();
    }
    else if(this.videoRenderer.videoPlayers.hasOwnProperty(adElementId) && typeof this.videoRenderer.videoPlayers[adElementId].play === 'function'){

        return this.videoRenderer.videoPlayers[adElementId].play();
    }

    return false;
};

//
// Pause if video.
window.adsNinja.pauseIfVideo = function(adElementId){

    var adsNinjaVideoPlayer = this.getVideoPlayer(adElementId);

    if(adsNinjaVideoPlayer && typeof adsNinjaVideoPlayer.pause === 'function'){

        return adsNinjaVideoPlayer.pause();
    }
    else if(this.videoRenderer.videoPlayers.hasOwnProperty(adElementId) && typeof this.videoRenderer.videoPlayers[adElementId].pause === 'function'){

        return this.videoRenderer.videoPlayers[adElementId].pause();
    }

    return false;
};

//
// Monitize dynamic content.
window.adsNinja.monetizeDynamicContent = function(elementId, zoneInfo, action = 'init', addintionalDetails = {}, content = ''){

    this.__waitForReadyEvent(function(){

        window.adsNinja.injector.monetizeDynamicContent(elementId, zoneInfo, action, addintionalDetails, content);
    });
};

//
// Monitize video.
window.adsNinja.monetizeVideo = function(targetSelector, zoneInfo, settings){

    // TODO: Use promises or allow use of a callback.
    // This is for the fallback to work it needs a bool response.
    // this.__waitForReadyEvent(function(){ 

        try{

            // HACK: Add default video playlist.
            // TODO: Remove when website is ready to pass suggestions.
            if(window.adsNinjaHeaderBiddingManager && window.adsNinjaHeaderBiddingManager.__videoList && window.adsNinjaHeaderBiddingManager.__videoList.length > 0){

                settings.playlist = settings.playlist || [];

                for(var i = 0; i < window.adsNinjaHeaderBiddingManager.__videoList.length; i++){

                    settings.playlist.push(window.adsNinjaHeaderBiddingManager.__videoList[i]);
                }
            }

            window.adsNinja.injector.monetizeVideo(targetSelector, zoneInfo, settings);

            return true;
        }
        catch(error){

            window.adsNinja.logger.warn('Unable to monetize video.', {
                targetSelector: targetSelector,
                zoneInfo: zoneInfo,
                settings: settings,
                error: error,
            }, false);

            return false;
        }
    // });
};

//
// Monitize table.
window.adsNinja.monetizeTable = function(target, zoneInfo, additionalDetails = {}){

    this.__waitForReadyEvent(function(){

        try{

            window.adsNinja.injector.monetizeTable(target, zoneInfo, additionalDetails);
        }
        catch(error){
            
            window.adsNinja.logger.warn('Unable to monetize table.', {
                target: target,
                zoneInfo: zoneInfo,
                error: error,
            }, false);
        }
    });
};

//
// Monitize list.
window.adsNinja.monetizeList = function(target, zoneInfo, additionalDetails = {}){

    this.__waitForReadyEvent(function(){

        try{

            window.adsNinja.injector.monetizeList(target, zoneInfo, additionalDetails);
        }
        catch(error){
            
            window.adsNinja.logger.warn('Unable to monetize list.', {
                target: target,
                zoneInfo: zoneInfo,
                error: error,
            }, false);
        }
    });
};

//
// Monetize rail.
window.adsNinja.monetizeRail = function(target, zoneInfo, additionalDetails = {}){
    
    this.__waitForReadyEvent(function(){

        try{
            
            window.adsNinja.injector.monetizeRail(target, zoneInfo, additionalDetails);
        }
        catch(error){
            
            window.adsNinja.logger.warn('Unable to monetize rail.', {
                target: target,
                zoneInfo: zoneInfo,
                error: error,
            }, false);
        }
    });
}

//
// Generate UUID,
window.adsNinja.generateUUID = function(){

    var uuid;
    
    // Check if crypto.randomUUID() is supported.
    if(typeof crypto.randomUUID === 'function'){
        
        uuid = crypto.randomUUID();
    } 
    else{
        
        // Fallback method for generating UUIDs.
        uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c){
            
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : (r & 0x3 | 0x8);

            return v.toString(16);
        });
    }
    
    return uuid;
};

//
// Scheduled queue.
window.adsNinja.scheduleOnReadyState = function(readyState, callback){
    
    var options = false;

    if(window.adsNinja.eventHelper.arePassiveEventListenersSupported()){

        options = { passive: true };
    }

    if(document.readyState === readyState || document.readyState === 'complete' || readyState === 'loading'){
        
        callback();
    }
    else{
        
        document.addEventListener('readystatechange', function(event){
            
            window.adsNinja.logger.debug(`Readystate: ${event.target.readyState}. Running scheduled callback.`, {
                readyState: readyState,
                callback: callback,
            });

            if(document.readyState === readyState){
                
                callback();
            }
        }, options);
    }
};

//
// Determine state associated with event.
window.adsNinja.__getAssociatedState = function(eventName){
    
    switch(eventName){
        
        case 'ANInitialized':
            
            return 1;

        case 'ANStarted':
            
            return 2;

        case 'ANReady':
            
            return 3; 
    }

    return null;
};

//
// Wait for ready state.
window.adsNinja.__waitForReadyEvent = function(callback){
    
    // Wait for ready state.
    if(3 === this.state){

        callback();
    }
    else{

        this.addEventListener('ANReady', callback);
    }
};

//
// Add event listener.
window.adsNinja.addEventListener = function(eventName, callback){
    
    var associatedState = this.__getAssociatedState(eventName);

    // TODO: Remove when we are handling more events.
    if(!associatedState){

        throw new Error(`Unable to add event listener for event: ${eventName}.`);
    }

    if(associatedState <= this.state){

        callback();
    }

    window.addEventListener(eventName, callback);
};

//
// Try processing queue.
// Closures in queue should have their own error handling for anything missing.
// Also needed to init Valstream video players when no ads or defined ad zone are available.
if(window.adsNinja.isInjectorInjected){

    window.adsNinja.scheduleOnReadyState('interactive', function(){

        window.adsNinja.init();
    });
}
else{

    window.adsNinja.scheduleOnReadyState('complete', function(){

        window.adsNinja.init();
    });
}

// For backwards compatibility.
window.adsNinjaDynamicallyInjectAllAdZones = window.adsNinja.dynamicallyInjectAllAdZones;
